import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentFollowups() {
  return (
    <FulfillmentQueue
      title="Followups"
      statusFilter="followup"
      emptyMessage="No followup orders"
      extraColumns={[
        {
          headerName: 'Followup Notes',
          field: 'followup_notes',
          width: 160,
          cellStyle: { display: 'flex', alignItems: 'center', color: 'var(--ink-secondary)' },
        },
      ]}
    />
  );
}
